import TwoTwoEightFourList from './2284List/2284List';

const TwoTwoEightFour = () => {
  return (
    <>
      <TwoTwoEightFourList />
    </>
  );
};

export default TwoTwoEightFour;
